import dayjs from "dayjs";
import { City } from "src/containers/home/types";

export function getCookie(name: string): string {
  if (isWindowPresent) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return "";
  } else {
    return "";
  }
}

export const isWindowPresent = typeof window !== "undefined" && !!window;

export const isEmpty = (
  obj: undefined | Record<string, any> | Record<string, never> | string | null
): boolean => {
  if (obj instanceof Date) {
    return false;
  }
  // null and undefined are "empty"
  if (obj == null || typeof obj === "undefined") {
    return true;
  }

  const isNumber = (value: any) =>
    Object.prototype.toString.call(value) === "[object Number]";
  const isNaN = (value: any) => isNumber(value) && value.toString() === "NaN";

  if (isNumber(obj)) {
    return isNaN(obj);
  }

  /** Assume if it has a length property with a non-zero value
   * that that property is correct.
   */
  if (obj.length > 0) {
    return false;
  }
  if (obj.length === 0) {
    return true;
  }

  /** If it isn't an object at this point
   * it is empty, but it can't be anything *but* empty
   * Is it empty?Depends on your application.
   */
  if (typeof obj !== "object") {
    return true;
  }

  /**Otherwise, does it have any properties of its own?
   * Note that this doesn't handle
   * toString and valueOf enumeration bugs in IE < 9
   */
  const keys = Object.keys(obj);
  for (let i = 0, key = keys[i]; i < keys.length; i += 1) {
    if (obj.hasOwnProperty.call(obj, key)) {
      return false;
    }
  }
  return true;
};

export interface RecentSearchData {
  arrival: City;
  departure: City;
  journeyDate: string;
}
export function updateRecentSearch(searchData: RecentSearchData) {
  try {
    if (typeof window.localStorage != "undefined") {
      const storageName = "busSearchHistory";
      const searchHistory: RecentSearchData[] = [];
      const localStorageData = localStorage.getItem(storageName);
      const recentSearch =
        localStorageData !== null
          ? JSON.parse(localStorageData)
          : searchHistory;

      let eleFound = false;

      // checking if duplicate search
      if (recentSearch.length) {
        for (let i = 0; i < recentSearch.length; i++) {
          if (
            recentSearch[i].departure.cityName ==
              searchData.departure.cityName &&
            recentSearch[i].arrival.cityName == searchData.arrival.cityName &&
            recentSearch[i].journeyDate == searchData.journeyDate
          ) {
            const shiftElement = recentSearch[i];
            recentSearch.splice(i, 1);
            recentSearch.unshift({ ...shiftElement });
            eleFound = true;
            break;
          }
        }
      }
      if (
        !eleFound &&
        searchData?.departure?.cityName &&
        searchData?.departure?.cityName !== "undefined" &&
        searchData?.arrival?.cityName &&
        searchData?.arrival?.cityName !== "undefined" &&
        searchData?.journeyDate
      ) {
        recentSearch.unshift({ ...searchData });
      }
      if (recentSearch.length >= 3) {
        recentSearch.length = 3;
      }

      localStorage.setItem(storageName, JSON.stringify(recentSearch));
    }
  } catch (e) {
    console.error("updateRecentSearch Local storage Error", e);
  }
}

export function getRecentSearch() {
  try {
    if (typeof window.localStorage != "undefined") {
      const storageName = "busSearchHistory";
      const searchHistory: RecentSearchData[] = [];
      const localStorageData = localStorage.getItem(storageName);
      const recentSearch =
        localStorageData !== null
          ? JSON.parse(localStorageData)
          : searchHistory;

      recentSearch.forEach((item: RecentSearchData, index: number) => {
        if (dayjs(item.journeyDate).isBefore(dayjs(), "day")) {
          recentSearch.splice(index, 1);
          localStorage.setItem(storageName, JSON.stringify(recentSearch));
        }
      });

      return recentSearch;
    } else {
      return [];
    }
  } catch (e) {
    console.error("getRecentSearch Local storage Error", e);
  }
}

export const updateQueryParam = (paramKey: string, paramValue: string) => {
  const url = new URL(window.location.href);

  const params = new URLSearchParams(url.search);

  params.set(paramKey, paramValue);

  const newQueryString = params.toString();

  history.replaceState({}, "", `${window.location.pathname}?${newQueryString}`);
};

export const removeQueryParam = (paramKey: string) => {
  const url = new URL(window.location.href);

  url.searchParams.delete(paramKey);

  history.replaceState({}, "", url.toString());
};

export const updateMarTechBookingCount = () => {
  const marTechUserData = sessionStorage.getItem("martech_user_attributes");

  try {
    if (marTechUserData) {
      const parsedData = JSON.parse(marTechUserData);
      const bookingStatusData = { ...parsedData.bookingStatus };
      bookingStatusData.lifetimeBooking += 1;
      bookingStatusData.postmergerBooking += 1;

      bookingStatusData.lastOneYearBooking += 1;
      bookingStatusData.secondLastbookingDate =
        bookingStatusData.lastbookingDate;
      bookingStatusData.lastbookingDate = dayjs().unix();
      parsedData.bookingStatus = bookingStatusData;
      sessionStorage.setItem(
        "martech_user_attributes",
        JSON.stringify(parsedData)
      );
    }
  } catch (err) {
    console.error(err);
  }
};
